import React, { useState, useEffect } from "react";
import {
  Button,
  ButtonGroup,
  Dropdown,
  Form,
  Row,
  Col,
  Modal,
  Pagination,
} from "react-bootstrap";
import { GiTakeMyMoney } from "react-icons/gi";
import { FaEye } from "react-icons/fa";
import { HiDocumentText } from "react-icons/hi";
import EditSalaryLayouts from "../../components/EditSalaryLayout.jsx";
import PFlayout from "../../components/PFLayouts.jsx";
import { Link } from "react-router-dom";
import "./provident-fund.css";

export default function ProvidentFund() {
  const rowsPerPage = 10; // ✅ Ensure only 10 rows per page
  const [currentPage, setCurrentPage] = useState(1);
  const [data, setData] = useState([]); 
  const [totalEntries, setTotalEntries] = useState(0); 
  const [loading, setLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [modalData, setModalData] = useState({});

  // ✅ Fetch Data from API
  const fetchPFUsers = async () => {
    setLoading(true);
    try {
      const response = await fetch(
        `https://backend.ems.hiradentallab.com/api/pf/all?page=${currentPage}&limit=${rowsPerPage}`
      );
      const result = await response.json();

      console.log("API Response:", result); // 🔍 Debugging API Response

      setData(result.data || []);
      setTotalEntries(result.totalEntries ?? result.data.length); // ✅ Ensure totalEntries is set correctly

    } catch (error) {
      console.error("Fetch error:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchPFUsers();
  }, [currentPage]);

  const handleShowModal = (item) => {
    setModalData({
      name: item.userDetails?.name || "N/A",
      role: item.userDetails?.role || "N/A",
      balance: item.pfDetails?.balance || 0,
    });
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
  };

  const handlePageChange = (pageNumber) => {
    if (pageNumber >= 1 && pageNumber <= Math.ceil(totalEntries / rowsPerPage)) {
      setCurrentPage(pageNumber);
    }
  };

  // ✅ Fix Showing "NaN" in Entries
  const startEntry = totalEntries > 0 ? (currentPage - 1) * rowsPerPage + 1 : 0;
  const endEntry = totalEntries > 0 ? Math.min(currentPage * rowsPerPage, totalEntries) : 0;

  return (
    <EditSalaryLayouts>
      <PFlayout>
        <h1 className="provident-fund-title">
          <GiTakeMyMoney /> Provident Fund
        </h1>
        <hr />
        <div className="provident-fund-container">
          <div className="provident-fund-actions">
            <Row>
              <Col xs={12} md={6} className="d-flex align-items-center mb-2">
                <Dropdown as={ButtonGroup}>
                  <Button variant="primary">Show Entries</Button>
                  <Dropdown.Toggle split variant="primary" id="dropdown-split-basic" />
                  <Dropdown.Menu>
                    <Dropdown.Item as="button">10</Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown>
              </Col>
              <Col xs={12} md={6} className="d-flex justify-content-end mb-2">
                <div className="provident-fund-search-container">
                  <Form className="d-flex">
                    <Form.Control
                      type="search"
                      placeholder="Search"
                      aria-label="Search"
                      className="provident-fund-search"
                    />
                  </Form>
                </div>
              </Col>
            </Row>
          </div>

          <div className="table-responsive">
            <table className="table table-striped table-style">
              <thead className="provident-fund-table-header">
              <tr className="table-header">
                <th>SR</th>
                <th>Name</th>
                <th>Role</th>
                <th>Amount</th>
                <th>withdrawableAmount</th>
                <th>Action</th>
              </tr>
              </thead>
              <tbody>
              {loading ? (
                  <tr>
                    <td colSpan="5" style={{textAlign: "center"}}>Loading...</td>
                  </tr>
              ) : data.length > 0 ? (
                  data.slice(0, 10).map((item, index) => ( // ✅ Ensures only 10 rows display
                      <tr key={item.pfDetails._id}>
                        <td>{(currentPage - 1) * rowsPerPage + index + 1}</td>
                        <td>{item.userDetails?.name || "N/A"}</td>
                        <td>{item.userDetails?.role || "N/A"}</td>
                        <td>{item.pfDetails?.balance || 0}</td>
                        <td>{item.pfDetails?.withdrawableBalance || 0}</td>

                        <td>
                          <Button className="btn-btn-primary" onClick={() => handleShowModal(item)}>
                            <FaEye/>
                          </Button>
                          <Link to="/PF-user">
                            <Button className="doc-button">
                              <HiDocumentText/>
                            </Button>
                          </Link>
                        </td>
                      </tr>
                  ))
              ) : (
                  <tr>
                    <td colSpan="5" style={{textAlign: "center"}}>No data available</td>
                  </tr>
              )}
              </tbody>

              <tfoot className="provident-fund-footer">
              <tr className="provident-fund-table-footer">
                <td colSpan="5">
                  Showing {startEntry} to {endEntry} of {totalEntries} entries
                </td>
              </tr>
              </tfoot>
            </table>

            {/* ✅ Fixed Pagination */}
            <div className="pagination-container">
              <Row className="custom-row">
                <Col xs={12} md={9} className="custom-col-left">
                  Showing {startEntry} to {endEntry} of {totalEntries} entries
                </Col>
                <Col xs={12} md={3} className="custom-col-right">
                  <nav>
                    <Pagination>
                      <Pagination.Prev
                          disabled={currentPage === 1}
                          onClick={() => handlePageChange(currentPage - 1)}
                      />
                      {Array.from({length: Math.ceil(totalEntries / rowsPerPage)}, (_, i) => i + 1).map((pageNumber) => (
                          <Pagination.Item
                              key={pageNumber}
                              active={currentPage === pageNumber}
                              onClick={() => handlePageChange(pageNumber)}
                          >
                            {pageNumber}
                          </Pagination.Item>
                      ))}
                      <Pagination.Next
                          disabled={currentPage === Math.ceil(totalEntries / rowsPerPage)}
                          onClick={() => handlePageChange(currentPage + 1)}
                      />
                    </Pagination>
                  </nav>
                </Col>
              </Row>
            </div>
          </div>
        </div>

            {/* Modal */}
            <Modal show={showModal} onHide={handleCloseModal}>
              <Modal.Header closeButton>
                <Modal.Title>Provident Fund Details</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <p><strong>Name:</strong> {modalData.name}</p>
                <p><strong>Role:</strong> {modalData.role}</p>
                <p><strong>Amount:</strong> {modalData.balance}</p>
              </Modal.Body>
              <Modal.Footer>
                <Button variant="primary" onClick={handleCloseModal}>Close</Button>
              </Modal.Footer>
            </Modal>
      </PFlayout>
    </EditSalaryLayouts>
);
}

